$(function () {
    "use strict";
    
    $(".gallery-image-container img").click(function () {
        var src = $(this).attr("src");
        console.log(src);
        $(".show").fadeIn();
        $('.nav-inline-desktop').css({"z-index":"0"});
        $(".img-show img").attr("src", src);
    });
    
    $("span, .overlay").click(function () {
        $(".show").fadeOut();
        $('.nav-inline-desktop').css({"z-index":"25"});
    });
    
});